import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Select2OptionData } from 'ng2-select2';
import swal from 'sweetalert2';
import { DataContract } from '../../../shared/models/data-contract.model';
import { RefundRequestHisto } from '../../../shared/models/request-refund-histo.model';
import { RefundRequest } from '../../../shared/models/request-refund.model';
import { RequestState } from '../../../shared/models/request-state.model';
import { RequestFileLoad } from "../../../shared/models/request-file-load.model";
import { RefundRequestInvoiceItem } from "../../../shared/models/request-refund-invoice-item.model";
import { User } from '../../../shared/models/user.model';
import { BancosService } from '../../../shared/services/bancos.service';
import { RefundService } from '../../../shared/services/refund.service';
import { SessionService } from '../../../shared/services/session.service';
import { DateUtility } from '../../../shared/utilities/date.utility';
import { CitieService } from '../../../shared/services/citie.service';
import { Lista } from '../../../shared/models/lista.model';
import { Beneficiary } from '../../../shared/models/beneficiary.model';
import { BeneficiaryService } from '../../../shared/services/beneficiary.service';
import { CheckboxItem } from '../../../shared/models/checkbox-item.model';
import { RefundRequestFile } from '../../../shared/models/refund-request-file.model';
import { environment } from '../../../../environments/environment';
import { ListaSoportesReembolsos } from '../../../shared/models/lista-soportes_de-reembolsos.model';
import { SupportsOfRefundRequestInvoiceItem } from '../../../shared/models/supports-of-request-refund-invoice-item.model';

@Component({
    selector: 'app-request-refund',
    templateUrl: './request-refund.component.html',
})
export class RequestRefundComponent implements OnInit {

    public model: RefundRequest;

    public dataContractItem: DataContract;
    public userItem: User;
    public listaBeneficiarios: Beneficiary[];

    public existeData: boolean;

    public ciudades: Select2OptionData[];
    public bancos: Select2OptionData[];
    public beneficiarios: Select2OptionData[];    
    public numberRefunds: Select2OptionData[];
    public typesAccountsBank: Select2OptionData[];
    public tiposReembolsoFactura: Select2OptionData[];

    public tiposReembolsos: CheckboxItem[];

    public viewTableInvoices: boolean;
    public viewAppendInvoice: boolean;
    public listaFacturas: RefundRequestInvoiceItem[] = [];
    public itemFactura: RefundRequestInvoiceItem;
    public archivoFactura: File;
    public archivoFacturaBase64: string


    showSpinnerLoading: boolean;
    showLoadCertificateAccount: boolean;
    cReembolsos:number;
    arrEspecialidades: string[] = [];
    viewCheckboxs:boolean =false;
    cargo:boolean;

    public viewLoadFacturaOriginal: boolean;
    public viewLoadHistoriaClinica: boolean;
    public viewLoadResultadoExamenes: boolean;
    public viewLoadHojaPorSesion: boolean;
    public viewLoadFormulaMedicaDx: boolean;
    public viewLoadDescripcionProcedimiento: boolean;
    public viewLoadDescripcionQuirurgicaOrdenMedica: boolean;
    public viewLoadDescripcionQuirurgica: boolean;
    public viewLoadHistoriaEvolucion: boolean;
    public viewLoadTrasladoAmbulancia: boolean;
    public listAttachmentsFiles: RequestFileLoad[];

    public listaSoportesReembolsos: ListaSoportesReembolsos[] = [];

    // En este modelo se guardarán los archivos que se subiran
    // junto con otra información.
    // Por cada tipo de archivo y tipo de reembolso se creara un objeto y 
    // se agregará a esta lista.
    public refundRequestFileList: RefundRequestFile[] = [];

    // Cantidad de registros que se desea obtener al consultar las
    // cuentas bancarias que el usuario ha registrado
    public numeroRegistros: number = 1;

    public readonly htmlLabels: Object = {
        'BANK_CERTIFICATE': environment.REQUEST_REFUND.TYPES_OF_FILES.BANK_CERTIFICATE,
        'ORIGINAL_INVOICE': environment.REQUEST_REFUND.TYPES_OF_FILES.ORIGINAL_INVOICE,
        'CLINIC_HISTORY': environment.REQUEST_REFUND.TYPES_OF_FILES.CLINIC_HISTORY,
        'EXAM_RESULTS': environment.REQUEST_REFUND.TYPES_OF_FILES.EXAM_RESULTS,
        'EVOLUTION_SHEET_FOR_SESSION': environment.REQUEST_REFUND.TYPES_OF_FILES.EVOLUTION_SHEET_FOR_SESSION,
        'MEDICAL_FORMULA_DIAGNOSIS': environment.REQUEST_REFUND.TYPES_OF_FILES.MEDICAL_FORMULA_DIAGNOSIS,
        'PROCEDURE_DESCRIPTION': environment.REQUEST_REFUND.TYPES_OF_FILES.PROCEDURE_DESCRIPTION,
        'SURGICAL_DESCRIPTION_MEDICAL_ORDER': environment.REQUEST_REFUND.TYPES_OF_FILES.SURGICAL_DESCRIPTION_MEDICAL_ORDER,
        'SURGICAL_DESCRIPTION': environment.REQUEST_REFUND.TYPES_OF_FILES.SURGICAL_DESCRIPTION,
        'CLINICAL_HISTORY_EVOLUTION': environment.REQUEST_REFUND.TYPES_OF_FILES.CLINICAL_HISTORY_EVOLUTION,
        'AMBULANCE_TRANSFER_REPORT': environment.REQUEST_REFUND.TYPES_OF_FILES.AMBULANCE_TRANSFER_REPORT
      }

    constructor(
        private router: Router,
        private _sessionService: SessionService,
        private _beneficiaryService: BeneficiaryService,
        private _banckService: BancosService,
        private _citieService: CitieService,
        private _refundService: RefundService
    ) {
        this.model = new RefundRequest (
            0, "", "", "", "", "", "", 
            "", "", "", "", "", "",
            new RefundRequestHisto (
                "", "", "", "", "", "",
                "", "", "", "", "", "",
                "", "", "", "",
                [null],
                [null],
                new RequestState (
                    "", ""
                )
            )
        );

        this.itemFactura = new RefundRequestInvoiceItem(
            "", "", "", "", "", "", "", []
        );
    }

    ngOnInit() {

        this.showLoadCertificateAccount = false;
        this.viewTableInvoices = false;
        this.viewAppendInvoice = false;

        this.viewLoadFacturaOriginal = false;
        this.viewLoadHistoriaClinica = false;
        this.viewLoadResultadoExamenes = false;
        this.viewLoadHojaPorSesion = false;
        this.viewLoadFormulaMedicaDx = false;
        this.viewLoadDescripcionProcedimiento = false;
        this.viewLoadDescripcionQuirurgicaOrdenMedica = false;
        this.viewLoadDescripcionQuirurgica = false;
        this.viewLoadHistoriaEvolucion = false;
        this.viewLoadTrasladoAmbulancia = false;

        this.listAttachmentsFiles = [];

        this.dataContractItem = this._sessionService.getDataContract();
        this.userItem = this._sessionService.getCurrentUser();
       
        this.model.contrato = this._sessionService.getSelectContract();
        this.model.tipoContrato = this.dataContractItem.contractType;
        this.model.usuario = this.userItem.user;
        this.model.tipoPlan = this.dataContractItem.plan;
        this.model.idTipoDocumento = this.userItem.documentType == null ? "CC":this.userItem.documentType ;
        this.model.idDocumento = this.userItem.documentId;
        this.model.nombreCliente = this.dataContractItem.name;
        this.model.email = this.userItem.email; 
        this.model.telefonoFijo = this.userItem.residentialPhone;
        this.model.telefonoCelular = this.userItem.celphone; 

        let _fechahora = new Date();
        this.model.reembolsoSolicitudHisto.fechaRegistro = DateUtility.getDateFormat(_fechahora);
        let dateSend = this.model.reembolsoSolicitudHisto.fechaRegistro.split("/");
        this.model.reembolsoSolicitudHisto.fechaRegistro = dateSend[2]+"-"+dateSend[1]+"-"+dateSend[0];

        this.model.reembolsoSolicitudHisto.estadoSolicitud.idEstado ="2";
        this.model.reembolsoSolicitudHisto.estadoSolicitud.nombreEstado = "EE";

        this._citieService.getCities().subscribe(
            res => {
                let _res = this.toSelect2(res);
                let _optionCities = _res;
                let _options = _optionCities;
                this.ciudades = _options;
                this.model.reembolsoSolicitudHisto.idCiudadRes = this.ciudades[0].id;
                this.model.reembolsoSolicitudHisto.ciudadRes = this.ciudades[0].text;
            }
        )

        this.showSpinnerLoading = true;
        this._banckService.getBanks().subscribe(
            res => {
                let _array = [];
                for (let item of res) {
                    let _obj = {
                        id: item.id,
                        text: item.text
                    }
                    _array.push(_obj);
                }

                let _optionDefault = this.getOptionDefault();
                let _optionBancos = _array;
                let _options = _optionDefault.concat(_optionBancos);
                this.bancos = _options;
                this.showSpinnerLoading = false;
            },
            err => {
                this.showSpinnerLoading = false;
                console.log(err);
            }
        )

        this._refundService.getTiposReembolsos().subscribe(
            res => {
                let _array = [];
                for (let item of res) {
                    let _obj = {
                        idEstado: item.id,
                        nombreEstado: item.text,
                        isChecked: false,
                    }
                    _array.push(_obj);
                }                
                this.tiposReembolsos = _array;

                _array = [];
                for (let item of res) {
                    let _obj = {
                        id: item.id,
                        text: item.text,
                    }
                    _array.push(_obj);
                }
                let _optionDefault = this.getOptionDefault();
                let _optionTiposReembolso= _array;
                let _options = _optionDefault.concat(_optionTiposReembolso);
                this.tiposReembolsoFactura = _options;
            },
            err => {
                console.log(err);
            }
        )

        this._beneficiaryService.getBeneficiariesMedicalPanacea(
        this._sessionService.getSelectContract(),
        this._sessionService.getCurrentUser().documentId,
        this._sessionService.getSelectDocumentTypeContracted()
        ).subscribe(
            res => {
                this.listaBeneficiarios = res;

                let _array = [];
                for (let item of res) {
                    let _obj = {
                        id: item.documentoIdentidad,
                        text: item.nombre
                    }
                    _array.push(_obj);
                }

                let _optionDefault = this.getOptionDefault();
                let _optionBeneficiarios = _array;
                let _options = _optionDefault.concat(_optionBeneficiarios);
                this.beneficiarios = _options;
            },
            err => {
                console.log(err);
            }
        )

        let _array = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
                    11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
        let _newArray = [];
        for (let item of _array) {
            let _obj = {
                id: item,
                text: item
            }
            _newArray.push(_obj);
        }

        let _optionDefault = this.getOptionDefault();
        let _optionTipoReembolsos = _newArray;
        let _options = _optionDefault.concat(_optionTipoReembolsos);
        this.numberRefunds = _options;

        let _arrayTypeAccounts = [];
        let _obj = {
            id: 'AH',
            text: 'CUENTA AHORROS'
        }
        _arrayTypeAccounts.push(_obj);
        _obj = {
            id: 'CC',
            text: 'CUENTA CORRIENTE'
        }
        _arrayTypeAccounts.push(_obj);
        _optionDefault = this.getOptionDefault();
        let _optionTipoCuentas = _arrayTypeAccounts;
        _options = _optionDefault.concat(_optionTipoCuentas);
        this.typesAccountsBank = _options;

        this.getlistaSoportesReembolsos();
        this.getUltimasCuentasBancarias();
    }

    getlistaSoportesReembolsos() {
        this._refundService.getListaSoportesDeReembolsos().subscribe(res => {
            this.listaSoportesReembolsos = res;
        });
    }

    getUltimasCuentasBancarias() {
        this._refundService.getUltimasCuentasBancarias(this.model.contrato, this.numeroRegistros).subscribe(res => {
            if(res.length > 0) {
                let ultimaCuentaRegistrada = res[0];
                this.model.reembolsoSolicitudHisto.titular = ultimaCuentaRegistrada.titular;
                this.model.reembolsoSolicitudHisto.cuentaBancaria = ultimaCuentaRegistrada.cuentaBancaria;
                this.model.reembolsoSolicitudHisto.codBanco = ultimaCuentaRegistrada.codigoBanco.toString();
                this.model.reembolsoSolicitudHisto.nombreBanco = ultimaCuentaRegistrada.nombreBanco;
    
                if(ultimaCuentaRegistrada.tipoCuenta == "A") {
                    this.model.reembolsoSolicitudHisto.tipoCuenta = "AH";   
                }
                else{
                    this.model.reembolsoSolicitudHisto.tipoCuenta = "CC";   
                } 
    
                this.showLoadCertificateAccount = true;
            } 
            else {
                this.model.reembolsoSolicitudHisto.codBanco = this.getOptionDefault()[0].id;
                this.model.reembolsoSolicitudHisto.tipoCuenta = this.getOptionDefault()[0].id;
            }
        });
    }

    irHomeRefunds() {
        this.router.navigate(['/office/refunds/home']);
    }

    irDatosBasicos() {
        this.removeClass();
        jQuery("#stepDatosBasicos").addClass("active");
        jQuery("#tabDatosBasicos").addClass("active");
    }    

    changedEmail(newValue : string): void {
        this.model.email = newValue;
    }

    changedPhoneHome(newValue : string): void {
        this.model.telefonoFijo = newValue;
    }

    changedPhoneMobile(newValue : string): void {
        this.model.telefonoCelular = newValue;
    }

    changedCiudades(e: any): void {
        this.model.reembolsoSolicitudHisto.idCiudadRes = e.value;
        this.model.reembolsoSolicitudHisto.ciudadRes = e.data[0].text;
    }

    changedDireccionresidencia(newValue : string): void {
        this.model.reembolsoSolicitudHisto.direccionResidencia = newValue;
    }

    changedBancos(e: any): void {
        this.model.reembolsoSolicitudHisto.codBanco = e.value;
        if(e.data[0] != undefined) {
             this.model.reembolsoSolicitudHisto.nombreBanco = e.data[0].text;
        }   
    }

    changedAccountBanckNumber(newValue : string): void {
        this.model.reembolsoSolicitudHisto.cuentaBancaria = newValue;
        this.showLoadCertificateAccount = true;
    }

    changedNameAccountBanck(newValue : string): void {
        this.model.reembolsoSolicitudHisto.titular = newValue;
    }

    changedTypesAccountsBank(e: any): void {
        this.model.reembolsoSolicitudHisto.tipoCuenta = e.value;
    }

    selectBankCertificateFile(event): void {
        if(event.target.files.length > 0) {
            this.deleteOldBankCertificateFile();

            this.createNewRefundRequestFileModel(event.target.files[0]
                , null
                , null
                , environment.REQUEST_REFUND.TYPES_OF_FILES.BANK_CERTIFICATE);
        }        
    }

    // Este método se usa cuando se carga un certificado bancario nuevamente
    // Solo se permite un archivo para certificado bancario, por lo tanto
    // si ya hay un archivo de certificado cuando se carga otro, se elimina el anterior
    deleteOldBankCertificateFile(): void {
        let refundRequestFile = this.findRefundRequestFile(null,  environment.REQUEST_REFUND.TYPES_OF_FILES.BANK_CERTIFICATE);

        if(refundRequestFile != undefined) {
            refundRequestFile.files.splice(0, 1);
        } 
    }

    async createNewRefundRequestFileModel(file: File
        , refundTypeName?: string
        , numberOfFilesAllowed?: number
        , supportFileType?: string) { 

        let refundRequestFile = this.findRefundRequestFile(refundTypeName, supportFileType);
 
        if(refundRequestFile == undefined) {
            let newRefundRequestFile = new RefundRequestFile();
            newRefundRequestFile.contract = this.model.contrato;
            newRefundRequestFile.refundTypeName = refundTypeName;
            newRefundRequestFile.numberOfFilesAllowed = numberOfFilesAllowed;
            newRefundRequestFile.supportFileType = supportFileType;

            let fileBase64 = await this.convertFileToBase64(file, refundTypeName, supportFileType);

            newRefundRequestFile.files.push(fileBase64);
    
            this.refundRequestFileList.push(newRefundRequestFile); 
        }  
        else {
            let fileBase64 = await this.convertFileToBase64(file, refundTypeName, supportFileType);
            refundRequestFile.files.push(fileBase64);             
        }

        this.addSupportFileNameToItemFactura(file.name, supportFileType);
    }   

    findRefundRequestFile(refundTypeName?: string, supportFileType?: string): RefundRequestFile {
        return this.refundRequestFileList.find(rfl => rfl.refundTypeName == refundTypeName && rfl.supportFileType == supportFileType);
    }

    convertFileToBase64(file: File, refundTypeName: string, supportFileType: string) : Promise<RequestFileLoad> {
        var reader = new FileReader();
        reader.readAsBinaryString(file);

        return new Promise(resolve => {
            reader.onload = () => {
                var binaryString = reader.result.toString();
                let fileBase64 = btoa(binaryString);
        
                var splitNameFile = file.name.split(".");
     
                let fileToAdd = new RequestFileLoad();
                fileToAdd.fileBase64 = fileBase64;
                fileToAdd.fileName = splitNameFile[0];
                fileToAdd.fileExtension = splitNameFile[1];
    
                resolve(fileToAdd);
             };
        });
    };

    // Actualiza el modelo de this.itemFactura añadiendo el nombre del archivo cargado
    // en el modelo SupportsOfRefundRequestInvoiceItem que esta dentro de this.itemFactura
    addSupportFileNameToItemFactura(fileName: string, supportFileType: string): void {   
        if(supportFileType != environment.REQUEST_REFUND.TYPES_OF_FILES.BANK_CERTIFICATE) {
            let soporteDeFacturaItem = this.itemFactura.soportesDeFacturaItem.find(lsr => lsr.nombreSoporte == supportFileType);
            soporteDeFacturaItem.nombresSoportesAdjuntos.push(fileName);
        } 
    }

    irInformacionReembolso() {

        if (this.model.email === '') {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Debe digitar un Email...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }

        let EMAIL_REGEXP = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i;
        if (this.model.email != "" && (this.model.email.length <= 5 || !EMAIL_REGEXP.test(this.model.email))) {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">El Email digitado es invalido...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }
        

        let number_regex = /^[0-9]*$/;

        if(this.model.telefonoFijo != null){
            if(!(this.model.telefonoFijo.length == 0)){
                if (!number_regex.test(this.model.telefonoFijo) || this.model.telefonoFijo.length < 6) {
                    swal({
                        title: 'Solicitud Reembolsos',
                        html: '<p style="font-size:14px">El número de teléfono digitado es invalido...</p>',
                        type: 'warning',
                        confirmButtonClass: 'btn btn-primary',
                        buttonsStyling: false,
                        focusConfirm: false
                    });
                    return;
                }
            }
            
        }
        if (this.model.telefonoCelular === '') {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Debe digitar un número de celular...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }

        if (this.model.telefonoCelular == "" || this.model.telefonoCelular.length < 10 || this.model.telefonoCelular == null) {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">El número de celular digitado es invalido...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }
        /*
        Validar Checkbox
        */

        if (this.model.reembolsoSolicitudHisto.ciudadRes == '-1' || this.model.reembolsoSolicitudHisto.ciudadRes == '') {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Seleccione una ciudad de residencia...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }
        
        if (this.model.reembolsoSolicitudHisto.nombreBanco == '-1' || this.model.reembolsoSolicitudHisto.nombreBanco == '') {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Seleccione un Banco...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }

        if (this.model.reembolsoSolicitudHisto.cuentaBancaria === '') {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Debe digitar un número de cuenta...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }

        if (this.model.reembolsoSolicitudHisto.cuentaBancaria != "" && (this.model.reembolsoSolicitudHisto.cuentaBancaria.length < 8 || !number_regex.test(this.model.reembolsoSolicitudHisto.cuentaBancaria))) {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">El número de cuenta bancaria es invalido...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }

        if (this.model.reembolsoSolicitudHisto.titular === '') {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Debe digitar un Nombre Titular de la cuenta...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }

        let only_letters_regex = /^[a-zA-Z\s]*$/;
        if (this.model.reembolsoSolicitudHisto.titular != "" && (this.model.reembolsoSolicitudHisto.titular.length < 8 || !only_letters_regex.test(this.model.reembolsoSolicitudHisto.titular))) {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">El Nombre de Titular es invalido...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }

        if (this.model.reembolsoSolicitudHisto.tipoCuenta == '-1' || this.model.reembolsoSolicitudHisto.tipoCuenta == '') {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Seleccione un Tipo de Cuenta Bancaria...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }
        
        let missingBankCertificateFile = this.refundRequestFileList.find(rrfl => rrfl.supportFileType == environment.REQUEST_REFUND.TYPES_OF_FILES.BANK_CERTIFICATE) == undefined;

        if(missingBankCertificateFile){
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Debe cargar un certificado de cuenta bancaria...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;            
        }

        this.removeClass();
        jQuery("#stepInformacionReembolso").addClass("active");
        jQuery("#tabInformacionReembolso").addClass("active");
    }

    changedBeneficiarios(e: any): void {
        let _array = [];
        for (let item of this.listaBeneficiarios) {
            if(e.value === item.documentoIdentidad) {
                this.model.reembolsoSolicitudHisto.benIdTipoIdentificacion = item.tipoIdentificacion4;
                this.model.reembolsoSolicitudHisto.benNumeroIdentificacion = item.documentoIdentidad;
                this.model.reembolsoSolicitudHisto.benNombre = item.nombre;
            }
        }
    }

    changeNumberOfRefundsQuantity(e: any): void {

        // Se eliminan los objetos de reembolsos de esta lista 
        // incluyendo los archivos cargados,
        // a excepción del objeto que contiene el certificado bancario y su 
        // respectivo archivo
        this.deleteRefundRequestFile(1, this.refundRequestFileList.length -1);

        // Se vuelve a llamar este servicio, debido a que las cantidades
        // de documentos permitidos se modificaron en el modelo
        this.getlistaSoportesReembolsos();

        this.contChecked =0;
        this.tiposReembolsos.forEach(ele =>{
            //habilito los check's
            if (this.viewCheckboxs) {
                (<HTMLInputElement>document.getElementById(ele.nombreEstado)).disabled = false;
            }
        });
        this.tiposReembolsos.forEach(ele =>{
            //desCheckeo los check previamente seleccionados
            if (this.viewCheckboxs) {
                (<HTMLInputElement>document.getElementById(ele.nombreEstado)).checked = false;
            }
            ele.isChecked = false;
        });
        this.viewTableInvoices = false;
        this.model.reembolsoSolicitudHisto.cantidadReembolsos = e.value;
        if(this.cReembolsos < e.value){
            this.tiposReembolsos.forEach(ele =>{                
                (<HTMLInputElement>document.getElementById(ele.nombreEstado)).disabled = false;
            });
            this.viewTableInvoices = false;
            this.viewAppendInvoice = false;
            this.arrEspecialidades = [];
        }
        this.cReembolsos = e.value;
        if(this.model.reembolsoSolicitudHisto.cantidadReembolsos != "" && e.value != -1) {
            this.listaFacturas = new Array<RefundRequestInvoiceItem>();
        } else {
            this.viewTableInvoices = false;
            this.viewAppendInvoice = false;
            this.arrEspecialidades = [];
            this.listaFacturas = null;
        }

        this.viewCheckboxs = true
    }


    contChecked:number = 0;
    changedTiposReembolsos(index,eve): void {

        let listar:boolean = false;
        
        if((<HTMLInputElement>document.getElementById(eve.target.id)).checked){
            this.contChecked++
        }

        if(this.contChecked >= this.cReembolsos){
            this.tiposReembolsos.forEach(ele =>{
                //Deshabilito botones al llegar a la cantidad seleciconada
                (<HTMLInputElement>document.getElementById(ele.nombreEstado)).disabled = true;
            });
            listar = true;
            this.viewTableInvoices = true;
            this.viewAppendInvoice = true;
        }else{
            this.tiposReembolsos.forEach(ele =>{
                (<HTMLInputElement>document.getElementById(ele.nombreEstado)).disabled = false;
            });
        }        

        if(listar){
            this.arrEspecialidades =[];
            this.arrEspecialidades.push("Seleccione...");
            this.tiposReembolsos.forEach(e =>{
                let isChecke = (<HTMLInputElement>document.getElementById(e.nombreEstado)).checked;
                if (isChecke) {
                    this.arrEspecialidades.push(e.nombreEstado);
                }
            });
        }
    }

    changedItemInvoiceIdInvoice(newValue : string): void {
        this.itemFactura.idFactura = newValue;
    }

    changedItemInvoiceNitCompanyInvoice(newValue : string): void {
        this.itemFactura.nitFactura = newValue;
    }

    changedTypeRefundInvoice(e: any): void {
        this.itemFactura.idEspecialidadReembolso = e.value;
        this.itemFactura.nombreEspecialidadReembolso = e.data[0].text;
        this.assignSupportsToItemFactura();        
    }

    // Se asigna el modelo de los soportes que tiene el tipo de reembolso seleccionado
    // en this.itemFactura
    assignSupportsToItemFactura(): void {
        let soportesDeReembolso = this.listaSoportesReembolsos.filter(lsr => lsr.nombreReembolso.toUpperCase() == this.itemFactura.nombreEspecialidadReembolso);

        let soportesDeItemFactura: SupportsOfRefundRequestInvoiceItem[] = [];

        soportesDeReembolso.forEach(soporteDeReembolso => {
            let soporteDeItemFactura = new SupportsOfRefundRequestInvoiceItem(
                soporteDeReembolso.codSoporte
                , soporteDeReembolso.nombreSoporte
                , soporteDeReembolso.cantidadDocumentosPermitidos
                , new Array<string>()
            );

            soportesDeItemFactura.push(soporteDeItemFactura);
        });

        this.itemFactura.soportesDeFacturaItem = soportesDeItemFactura;   
    }

    changedItemInvoiceAmountInvoice(newValue : string): void {
        this.itemFactura.montoFactura = newValue;
    }

    changedDateInvoice(newValue : string): void {
        this.itemFactura.fechaFactura = newValue;
        let _dateAux = new Date(newValue);
    }

    selectSupportFile(event, numberOfFilesAllowed, supportFileType): void {

        let fileAlreadyExist = this.fileAlreadyExist(event.target.files[0], this.itemFactura.nombreEspecialidadReembolso, supportFileType);

        if(event.target.files.length > 0 && !fileAlreadyExist) {
            this.updateNumberOfFilesAllowedInItemFactura(-1, supportFileType);

            this.createNewRefundRequestFileModel(event.target.files[0]
                , this.itemFactura.nombreEspecialidadReembolso
                , numberOfFilesAllowed
                , supportFileType);
        }  
    }

    fileAlreadyExist(file: File, refundTypeName: string, supportFileType: string): boolean {
        let refundRequestFile = this.findRefundRequestFile(refundTypeName,  supportFileType);

        if(refundRequestFile != undefined) { 
            let fileAlreadyExist = refundRequestFile.files.find(f => f.fileName ==  file.name.split('.')[0]) != undefined;

            if(fileAlreadyExist) {
                swal({
                    title: 'Solicitud Reembolsos',
                    html: '<p style="font-size:14px">El archivo que selecciono ya esta cargado...</p>',
                    type: 'warning',
                    confirmButtonClass: 'btn btn-primary',
                    buttonsStyling: false,
                    focusConfirm: false
                });
                return true;
            }
        }  

        return false;
    }

    deleteSupportFile(indexInRefundRequestFileList, indexInSupportFileType, supportFileType): void {
        let refundTypeName = this.itemFactura.nombreEspecialidadReembolso;
        let refundRequestFile = this.findRefundRequestFile(refundTypeName, supportFileType);

        // Elimina el archivo del modelo this.refundRequestFileList 
        // pero no el objeto
        refundRequestFile.files.splice(indexInSupportFileType, 1);

        // Si el objeto de la lista this.refundRequestFileList
        // no tiene archivos, elimina el objeto completo de this.refundRequestFileList
        if(refundRequestFile.files.length == 0) {
            this.deleteRefundRequestFile(indexInRefundRequestFileList, 1);
        }

        this.deleteSupportFileNameInItemFactura(indexInSupportFileType, supportFileType);
        this.updateNumberOfFilesAllowedInItemFactura(1, supportFileType);
    }

    deleteRefundRequestFile(indexInRefundRequestFileList?, numberOfElements?): void {
        this.refundRequestFileList.splice(indexInRefundRequestFileList, numberOfElements);
    }

    deleteSupportFileNameInItemFactura(indexInSupportFileType, supportFileType: string): void {
        let supportFilesInItemFactura = this.itemFactura.soportesDeFacturaItem.find(sfi => sfi.nombreSoporte == supportFileType);
        supportFilesInItemFactura.nombresSoportesAdjuntos.splice(indexInSupportFileType, 1);
    }

    // Actualiza la cantidad de documentos permitidos en soportesDeFacturaItem de this.itemFactura
    updateNumberOfFilesAllowedInItemFactura(value: number, supportFileType: string): void {
        let supportFilesInItemFactura = this.itemFactura.soportesDeFacturaItem.find(sfi => sfi.nombreSoporte == supportFileType);
        supportFilesInItemFactura.cantidadDocumentosPermitidos = supportFilesInItemFactura.cantidadDocumentosPermitidos + value;
    }

    async appendInvoiceRefunds(): Promise<void> {

        if (this.itemFactura.idFactura === '') {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Debe digitar un Número de Factura...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }

        if (this.itemFactura.nitFactura === '') {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Debe digitar un Nit de Factura...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }

        if (this.itemFactura.idEspecialidadReembolso == '-1' || this.itemFactura.idEspecialidadReembolso == '') {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Seleccione un Tipo de Reembolso...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }

        if (this.itemFactura.montoFactura === '') {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Debe digitar el valor de la factura...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }

        if (this.itemFactura.fechaFactura === '') {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Debe seleccionar una fecha de factura...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;
        }

        let missingInvoiceFiles = this.findRefundRequestFile(this.itemFactura.nombreEspecialidadReembolso, environment.REQUEST_REFUND.TYPES_OF_FILES.ORIGINAL_INVOICE) == undefined
                        || this.findRefundRequestFile(this.itemFactura.nombreEspecialidadReembolso, environment.REQUEST_REFUND.TYPES_OF_FILES.ORIGINAL_INVOICE).files.length == 0;

        if(missingInvoiceFiles) {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Debe cargar un comprobante de factura...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return;            
        }

        if(!this.refundSpecialtyAlreadyAttached()) {
            this.listaFacturas.push(this.itemFactura);
            this.itemFactura = new RefundRequestInvoiceItem(
                "", "", "", "", "", "", "", []
            );

            if (this.listaFacturas.length === (+this.model.reembolsoSolicitudHisto.cantidadReembolsos)) {
                this.viewAppendInvoice = false;
            }
        } 
    }

    // Valida que no se anexe la misma expecialidad reembolso
    refundSpecialtyAlreadyAttached(): boolean {
        let refundTypeName = this.itemFactura.nombreEspecialidadReembolso;
        let refundSpecialtyAlreadyAttached = this.listaFacturas.find(lf => lf.nombreEspecialidadReembolso == refundTypeName);
        let message = '<p style="font-size:14px">El tipo de especialidad reembolso <b><i>' 
            + refundTypeName 
            + '</i></b>  ya esta anexada...</p>';

        if(refundSpecialtyAlreadyAttached != undefined) {
            swal({
                title: 'Solicitud Reembolsos',
                html: message,
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return true;
        }

        return false;
    }

    deleteInvoiceRefunds(index): void {
        this.listaFacturas.splice(index, 1);
        if (this.listaFacturas.length != (+this.model.reembolsoSolicitudHisto.cantidadReembolsos)) {
            this.viewAppendInvoice = true;
        }
    }

    changedReasonRefund(newValue : string): void {
        this.model.reembolsoSolicitudHisto.razonReembolso = newValue;
    }

    irSoportes() {

        if (this.model.reembolsoSolicitudHisto.benNombre == '-1' || this.model.reembolsoSolicitudHisto.benNombre == '') {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Seleccione un Beneficiario...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return false;
        }

        if (this.model.reembolsoSolicitudHisto.cantidadReembolsos == '-1' || this.model.reembolsoSolicitudHisto.cantidadReembolsos == '') {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Debe seleccionar cantidad de facturas a anexar...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return false;
        }

        if (this.listaFacturas.length != (+this.model.reembolsoSolicitudHisto.cantidadReembolsos)) {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Debe cargar y anexar por lo menos una factura por cada especialidad reembolso...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return false;
        }

        if (this.model.reembolsoSolicitudHisto.razonReembolso === '') {
            swal({
                title: 'Solicitud Reembolsos',
                html: '<p style="font-size:14px">Debe ingresar un motivo de solicitud de reembolso...</p>',
                type: 'warning',
                confirmButtonClass: 'btn btn-primary',
                buttonsStyling: false,
                focusConfirm: false
            });
            return false;
        }
        return true;
    }
    
    irConfirmacionRadicacion() {

        this.listaFacturas.forEach(e =>{
            this.model.reembolsoSolicitudHisto.listaFactura.push(e);
        });
        console.table(this.model.reembolsoSolicitudHisto.listaFactura);

        let rpt = this.irSoportes();
        if (!rpt) {
            return;
        }
        this.removeClass();
        jQuery("#stepConfirmacionRadicacion").addClass("active");
        jQuery("#tabConfirmacionRadicacion").addClass("active");
    }

    removeClass() {
        jQuery("ul.nav-tabs li").removeClass("active");
        jQuery("div.tab-pane").removeClass("active");
    }

    saveFin() {
        this.showSpinnerLoading = true;
        this.model.idReembolsoSolicitud = Math.floor(Math.random() * (1000000 - 1) + 1);

        const result = this.model.reembolsoSolicitudHisto.listaFactura.reduce((acc,item)=>{
            if(!acc.includes(item)){
                acc.push(item);
            }
            return acc;
        },[]);

        this.model.reembolsoSolicitudHisto.listaFactura = result;

        this._refundService.saveRequestRefund(this.model).subscribe(
            res => {
                let numRadicado = res.idReembolsoSolicitud;
                swal({
                    title: 'Solicitud de Reembolso Enviada Correctamente! \n ~ ' + numRadicado + ' ~ ',
                    type: 'success',
                    confirmButtonClass: 'btn btn-primary',
                    buttonsStyling: false,
                    focusConfirm: false
                });
                this.uploadFiles(numRadicado);
                this.newRefund();
            },
            err =>{
                swal('Error en Solicitud','error');
                this.showSpinnerLoading = false;
            }
        );
    }

    uploadFiles(numRadicado): void {
        this.refundRequestFileList.forEach(rrfl => {
            rrfl.idRefundRequest = numRadicado;
            rrfl.files.forEach(f => {
                this.uploadFileService(rrfl.contract
                    , this.model.reembolsoSolicitudHisto.benNumeroIdentificacion
                    , rrfl.idRefundRequest
                    , rrfl.refundTypeName
                    , rrfl.supportFileType
                    ,f);
            })
        });
    }

    uploadFileService(contract: string
        , userDocument: string
        , idRefundRequest: string
        , refundTypeName: string
        , supportFileType: string
        , file: RequestFileLoad): void {

        this._refundService.uploadFile(contract, userDocument, idRefundRequest, refundTypeName, supportFileType, file).subscribe(
            res => {
                if (res) {
                    console.log("Load");
                }
                this.showSpinnerLoading = false;
            }, err => {             
                console.log(err);
                this.showSpinnerLoading = false;
            }
        );
    }

    getOptionDefault(): any[] {
        return [{ id: '-1', text: 'Seleccione una opción...' }];
    }

    removeItemFromArr( arr, item ) {
        var i = arr.indexOf( item );
     
        if ( i !== -1 ) {
            arr.splice( i, 1 );
        }
    }

    toSelect2(source: Lista[]): any[] {

        var _array = [];
    
        for (let s of source) {
          let _obj = {
            id: s.id + '',
            text: s.text + ''
          };
          _array.push(_obj);
        }
    
        return _array;
      }
      newRefund(){
        this.showSpinnerLoading = false;
        this.router.navigate(['/office/refunds/home']);
      }
}


// WEBPACK FOOTER //
// /app/src/app/office/refunds/request-refund/request-refund.component.ts